import React, { useContext, useState } from "react";
import { ShopContext } from "../context/shop-context";
import {
  Box,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
} from "@mui/material";

const Checkout = () => {
  const { cartItems } = useContext(ShopContext);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [amount, setAmount] = useState("");
  const [message, setMessage] = useState(""); 

  // Convert cartItems object to an array of items
  const itemsArray = Object.values(cartItems); 
  // Calculate total price of all items in the cart
  const calculateTotalPrice = () =>
    itemsArray
      .reduce(
        (sum, item) =>
          sum + item.quantity * parseFloat(item.price.replace("ksh", "")),
        0
      )
      .toFixed(2);
  // Format cart items into a WhatsApp message
  const formatCartItems = () => {
    let message = `Hello @Whimssical Stitches, I'm interested in purchasing the items below\n Order Summary:\n`;
    itemsArray.forEach((item) => {
      message += `- ${item.name} (Quantity: ${item.quantity}, Price: ${item.price})\n`;
    });
    message += `\nTotal: ksh${calculateTotalPrice()}\nName: ${name}\nPhone: ${phone}\nKindly provide more details on these.`;
    return encodeURIComponent(message);
  };

  // Generate WhatsApp link
  const generateWhatsAppLink = () => {
    const whatsappNumber = "254718445847"; 
    const message = formatCartItems();
    return `https://wa.me/${whatsappNumber}?text=${message}`;
  };

  // Handle payment and WhatsApp order
const handlePayment = (e) => {
    e.preventDefault();
    fetch("http://localhost:5000/api/stkpush", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ phone: phone,  amount: amount }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setMessage('Payment successful!');
    // After payment initiation, send the cart items to WhatsApp
       window.open(generateWhatsAppLink(), "_blank");
      })
      .catch((error) => {
        console.error(error);
        setMessage('Payment failed!');
      });
  };


  return (
    <Box sx={{ padding: "20px" }}>
      
      <Typography variant="h4" gutterBottom>
        Checkout
      </Typography>
      {itemsArray.length === 0 ? (
        <Typography>
          Your cart is empty. Please add items to your cart.
        </Typography>
      ) : (
        <Box>
          
          <Typography variant="h5" gutterBottom>
            Order Summary
          </Typography>
          {itemsArray.map((item) => (
            <Card key={item.id} sx={{ marginBottom: "10px" }}>
              
              <CardContent
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                
                <Typography>{item.name}</Typography>
                <Typography>
                  
                  {item.quantity} x {item.price} = ksh
                  {(
                    item.quantity * parseFloat(item.price.replace("ksh", ""))
                  ).toFixed(2)}
                </Typography>
              </CardContent>
            </Card>
          ))}
          <Typography variant="h6" sx={{ marginTop: "20px" }}>
            
            Total Price: ksh{calculateTotalPrice()}
          </Typography>
        </Box>
      )}
      <form style={{ marginTop: "20px" }}>
        
        <Typography variant="h5">Payment Details</Typography>
        <TextField
          required
          label="Full Name"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          margin="normal"
        />
        <TextField
          required
          label="Phone Number"
          variant="outlined"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          sx={{ marginBottom: "1rem" }}
          fullWidth
        />
        <TextField
          label="Amount"
          variant="outlined"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          sx={{ marginBottom: "1rem" }}
          fullWidth
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handlePayment}
          sx={{
            marginTop: "20px",
            backgroundColor: "#1c0a49",
            "&:hover": { backgroundColor: "#cb6ce6" },
          }}
        >
          
          Pay with M-Pesa
        </Button>
        {message && <Typography>{message}</Typography>}
      </form>
    </Box>
  );
};
export default Checkout;
